/**
 * PATH: src/pages/pricing/components/PlanCard.jsx
 * PURPOSE: Reusable Card UI for each pricing plan
 * UI: Material UI Components
 */

import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Divider,
  Box,
  List,
  ListItem,
} from "@mui/material";

export default function PlanCard({ plan }) {
  const navigate = useNavigate();

  const price = (plan.amountCents / 100).toFixed(2);

  const handleSelectPlan = () => {
    navigate("/pricing/checkout", {
      state: {
        planCode: plan.code,
        revenueStream: plan.revenueStream,
      },
    });
  };

  return (
    <Card elevation={3} sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {plan.name}
        </Typography>

        <Typography variant="h4" fontWeight={800} color="primary">
          ₹{price}
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          {plan.billingInterval === "monthly"
            ? "/month"
            : plan.billingInterval === "yearly"
            ? "/year"
            : "one-time payment"}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Features:
          </Typography>

          <List dense>
            {plan.features?.map((f, idx) => (
              <ListItem key={idx} sx={{ pl: 0 }}>
                • {f}
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>

      <CardActions>
        <Button
          fullWidth
          variant="contained"
          size="large"
          color="primary"
          sx={{ borderRadius: 2 }}
          onClick={handleSelectPlan}
        >
          Choose Plan
        </Button>
      </CardActions>
    </Card>
  );
}
